import * as React from 'react'

import moment from 'moment'

import { observer } from 'mobx-react'

import createDateObjects from 'modules/timeoff/lib/createDateObjects'

import Day from './_Day'
import * as styles from './index.vanilla.css'
import { MunchedTree } from './store'

const FIRST_DAY_OF_THE_MONTH = 1

interface Props {
  dateTree: MunchedTree
  year: number
  month: number
  monthName: string
}

const Month = ({ dateTree, year, monthName, month }: Props) => {
  const day = FIRST_DAY_OF_THE_MONTH
  const date = moment([year, month, day])
  const dateObjects = createDateObjects(date)

  const daysInitials = []

  for (let i = 0; i < 7; i++) {
    const dayOfWeek = moment().weekday(i).format('dd')
    daysInitials.push(
      <span key={`days_initials_${i}`} className={styles.daysInitials}>
        {dayOfWeek}
      </span>
    )
  }

  return (
    <li className={styles.month}>
      <div className={styles.title}>{monthName}</div>
      <div className={styles.title}>{daysInitials.concat()}</div>
      <div className={styles.grid}>
        {dateObjects.map((dateObject, i) => (
          <Day dateTree={dateTree} dateObject={dateObject} key={`day_${i}`} />
        ))}
      </div>
    </li>
  )
}

export default observer(Month)
